import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
const STORAGE_KEY = 'tt.myWatch';
const API_URL = 'https://gapps.orcatec.net/api/devices.php';
const DeviceContext = createContext(undefined);
/** Gerätenamen ohne ®/™ für Anzeige und Suche */
export const cleanDeviceName = (name) => name.replace(/[®™]/g, '').replace(/\s+/g, ' ').trim();
let devicesPromise = null;
function loadDevices() {
    if (!devicesPromise) {
        devicesPromise = axios
            .get(API_URL, { timeout: 15000 })
            .then((res) => {
            const list = res.data?.data?.devices;
            if (!res.data?.success || !Array.isArray(list))
                return [];
            return list
                .filter((d) => d && d.id && d.name)
                .map((d) => ({ id: String(d.id), name: cleanDeviceName(d.name), urlName: d.urlName }))
                .sort((a, b) => a.name.localeCompare(b.name));
        })
            .catch(() => []);
    }
    return devicesPromise;
}
export const DeviceProvider = ({ children }) => {
    const [devices, setDevices] = useState([]);
    const [selectedId, setSelectedId] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY);
        }
        catch {
            return null;
        }
    });
    useEffect(() => {
        let cancelled = false;
        loadDevices().then((list) => {
            if (!cancelled)
                setDevices(list);
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const byId = useMemo(() => new Map(devices.map((d) => [d.id, d])), [devices]);
    const selected = selectedId ? byId.get(selectedId) ?? null : null;
    const select = useCallback((id) => {
        setSelectedId(id);
        try {
            if (id)
                localStorage.setItem(STORAGE_KEY, id);
            else
                localStorage.removeItem(STORAGE_KEY);
        }
        catch {
            /* Speicher nicht verfügbar */
        }
    }, []);
    const isCompatible = useCallback((product) => {
        if (!selected || !product.compatibleDeviceIds || product.compatibleDeviceIds.length === 0)
            return null;
        return product.compatibleDeviceIds.includes(selected.id);
    }, [selected]);
    const value = useMemo(() => ({ available: devices.length > 0, devices, byId, selected, select, isCompatible }), [devices, byId, selected, select, isCompatible]);
    return _jsx(DeviceContext.Provider, { value: value, children: children });
};
export function useDevices() {
    const ctx = useContext(DeviceContext);
    if (!ctx)
        throw new Error('useDevices must be used within DeviceProvider');
    return ctx;
}
